import {Injectable} from "@angular/core";
import {ConfigurationService} from "../configuration.service";

@Injectable()
export class OrderMappingService {

  events = new Map<string, string>();

  accounts = new Map<string, string>();

  constructor(private config: ConfigurationService) {
    this.events['bronze'] = 'FBEB';
    this.events['silver'] = 'FBES';
    this.events['gold'] = 'FBEG';
    this.events['bus'] = 'FBEBUS';
    this.events['bug'] = 'FBEBUG';
    this.events['sug'] = 'FBESUG';

    this.accounts['bronze-month-buy'] = 'FBB142';
    this.accounts['bronze-year-buy'] = 'FBB1242';
    this.accounts['bronze-month-subscribe'] = 'FBB042';
    this.accounts['silver-month-buy'] = 'FBS142';
    this.accounts['silver-year-buy'] = 'FBS1242';
    this.accounts['silver-month-subscribe'] = 'FBS042';
    this.accounts['gold-month-buy'] = 'FBG142';
    this.accounts['gold-year-buy'] = 'FBG1242';
    this.accounts['gold-month-subscribe'] = 'FBG042';
  }

  getId(key: string, eventId:string) {
    if(eventId!=null) {
      return this.getEventId(key);
    } else {
      return this.getAccountId(key);
    }
  }

  getEventId(key: string) {
    return this.events[key];
  }

  getAccountId(key: string) {
    if(this.config.getEnvironmentAsString()=='prod') {
      return this.accounts[key];
    } else {
      return 'DEV'+this.accounts[key];
    }
  }

  isSubscription(key: string, eventId:string): boolean {

    if(eventId!=null) {
      return false;
    }

    let accountId = this.accounts[key];

    if(accountId=='FBB042' || accountId=='FBS042' || accountId=='FBG042') {
      return true;
    }

    return false;
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/data/order-mapping.service.ts